import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8ae9f074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subs-list-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Subscriptions:", -1))
const _hoisted_3 = { class: "filter-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "display-cancelled" }, "Display cancelled subscriptions?", -1))
const _hoisted_5 = { class: "subs-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "data-export" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Package", -1))
const _hoisted_13 = { "data-test": "plan-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Start date", -1))
const _hoisted_15 = { "data-test": "sub-start-date" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { "data-test": "sub-end-date" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm glyphicon glyphicon-pencil" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Billing cycle", -1))
const _hoisted_23 = { "data-test": "sub-billing-cycle" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Invite code", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Status", -1))
const _hoisted_26 = { "data-test": "sub-status" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Owner", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 1,
  "data-test": "sub-no-owner"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Allow Open Invites", -1))
const _hoisted_32 = { class: "input-wrapper" }
const _hoisted_33 = { class: "switch" }
const _hoisted_34 = ["checked"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Total licences", -1))
const _hoisted_38 = { class: "licence-count" }
const _hoisted_39 = { "data-test": "sub-total-licences" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm glyphicon glyphicon-pencil" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Used licences", -1))
const _hoisted_43 = { "data-test": "sub-licence-use" }
const _hoisted_44 = { style: {"font-style":"italic"} }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Chargebee Subscription Id", -1))
const _hoisted_46 = { "data-test": "sub-chargebee-id" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Chargebee Customer Id", -1))
const _hoisted_48 = { "data-test": "sub-chargebee-customer" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Organisation has no licences", -1))
const _hoisted_51 = [
  _hoisted_50
]

import moment from "dayjs";
import { computed, ref } from "vue";
import axios, { AxiosError } from "axios";
import CancelSubscriptionModal from "./cancel-subscription-modal.vue";
import { jyreSubscriptionUids } from "../../../typings/enums/jyre-subscription-uids";
import { ChargebeeSubscriptionApiModel } from "../../../api-models";
import { useToggle } from "../../../composables/useToggle";


export default /*#__PURE__*/_defineComponent({
  __name: 'subscription-overview',
  props: {
    subscriptions: {}
  },
  emits: ["revalidate-org-data"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const displayCancelledSubscriptions = ref(false);

const filteredSubscriptions = computed(() => {
  return displayCancelledSubscriptions.value
    ? props.subscriptions
    : props.subscriptions?.filter((sub) => sub.status !== "Cancelled");
});

const activeSubscription = ref<ChargebeeSubscriptionApiModel | undefined>(
  props.subscriptions?.length ? filteredSubscriptions.value![0] : undefined,
);

const licenceUpdateError = ref("");
const openInviteSettingError = ref("");
const saveInProgress = ref(false);

const { state: isEditingLicenceCount, toggleState: toggleEditLicenceCount } = useToggle(false);

const { state: isCancelSubscriptionModalOpen, toggleState: toggleCancelSubscriptionModal } =
  useToggle(false);

const initialOpenInviteState = computed(() => {
  return activeSubscription.value?.allowOpenInviting ?? false;
});

const { state: openInviteState, toggleState: toggleOpenInviteState } = useToggle(
  initialOpenInviteState.value,
);

const licenceCount = computed(() => {
  return activeSubscription.value?.currentPaidLicenceCount;
});

const editedLicenceCount = ref(licenceCount.value);

const updatedLicenceCount = ref();

const { state: isEditingDeadline, toggleState: toggleEditDeadline } = useToggle(false);

const newDeadline = ref("");

const assessDeadlineError = ref("");

const dayAfterTomorrow = moment().add(2, "day").format("YYYY-MM-DD");

const cancelSubscriptionErrorMessage = ref<string | null>(null);

const subscriptionToCancelId = ref<string | null>(null);

const planTitle = computed(() => {
  const packageUid = activeSubscription.value ? activeSubscription.value?.prismicPackageUid : "";

  return packageUid
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
});

const getProductType = (subscription: ChargebeeSubscriptionApiModel) => {
  switch (subscription.prismicPackageUid) {
    case jyreSubscriptionUids.ASSESS:
      return "Assess";
    case jyreSubscriptionUids.PRO_TEAMS_PLAN:
      return "Perform";
    case jyreSubscriptionUids.FREE_PLAN:
      return "Free Plan";
    default:
      return "Unknown";
  }
};

const getSubscriptionDisplayName = (subscription: ChargebeeSubscriptionApiModel) => {
  const subscriptionName = subscription.subscriptionName
    ? subscription.subscriptionName
    : getProductType(subscription);
  return `${subscriptionName} - ${subscription.status}`;
};

const subscriptionStartDate = computed(() => {
  return activeSubscription.value
    ? moment(activeSubscription.value?.subscriptionStartTime).format("DD/MM/YYYY")
    : "";
});

const subscriptionEndDate = computed(() => {
  if (!activeSubscription.value) return "";

  let endMoment = moment(activeSubscription.value?.subscriptionEndTime);
  if (activeSubscription.value?.prismicPackageUid === jyreSubscriptionUids.ASSESS) {
    endMoment = endMoment.add(activeSubscription.value?.remainingBillingCycles ?? 0, "day");
  }

  return endMoment.format("DD/MM/YYYY");
});

const inviteCode = computed(() => {
  const code = activeSubscription.value ? activeSubscription.value?.inviteCode : "";

  if (window.location.href.includes("localhost")) {
    return `http://localhost:8080/invites/${code?.toLowerCase()}`;
  }
  if (window.location.href.includes("test")) {
    return `https://characterscope-test.azurewebsites.net/invites/${code?.toLowerCase()}`;
  }
  return `https://app.gyreteams.com/invites/${code.toLowerCase()}`;
});

const availableLicences = computed(() => {
  return activeSubscription.value
    ? `${
        (updatedLicenceCount.value! ?? licenceCount.value!) -
        activeSubscription.value?.licences.length
      } available`
    : "";
});

const setActiveSubscription = (subscription: ChargebeeSubscriptionApiModel) => {
  activeSubscription.value = subscription;
};

const isActive = (id: string) => {
  return activeSubscription.value?.id === id;
};

const copyInviteCode = async () => {
  try {
    await navigator.clipboard.writeText(inviteCode.value);
    // eslint-disable-next-line no-alert
    alert("Invite code copied to clipboard!");
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert("Cannot copy");
  }
};

const closeEditing = () => {
  licenceUpdateError.value = "";
  editedLicenceCount.value = licenceCount.value;
  toggleEditLicenceCount();
};

const updateLicenceCount = async () => {
  if (!editedLicenceCount.value) return;

  saveInProgress.value = true;
  try {
    const response = await axios.post(
      `/api/admin/updatelicencecount/${
        activeSubscription.value?.id
      }?newLicenceCount=${+editedLicenceCount.value}`,
    );
    updatedLicenceCount.value = response.data as number;
    toggleEditLicenceCount();
    saveInProgress.value = false;
  } catch (e) {
    licenceUpdateError.value = (e as AxiosError).response?.data ?? "Error updating licence count";
    saveInProgress.value = false;
  }
};

const isJyreAssess = computed(() => {
  return activeSubscription.value?.prismicPackageUid === jyreSubscriptionUids.ASSESS;
});

const updateAssessDeadline = async () => {
  if (newDeadline.value.length < 1) return;
  const id = activeSubscription.value?.id;
  const endDate = moment(newDeadline.value).format("DD/MM/YYYY");

  saveInProgress.value = true;
  try {
    await axios.post(`/api/admin/updateassessdeadline/${id}?deadline=${endDate}`);
    toggleEditDeadline();
    emit("revalidate-org-data");
    saveInProgress.value = false;
  } catch (e) {
    assessDeadlineError.value = (e as AxiosError).response?.data ?? "Error updating deadline";
    saveInProgress.value = false;
  }
  newDeadline.value = "";
};

const closeEditingDeadline = () => {
  assessDeadlineError.value = "";
  toggleEditDeadline();
};

const onToggleOpenInviting = async () => {
  openInviteSettingError.value = "";
  saveInProgress.value = true;
  try {
    await axios.post(
      `/api/admin/updateopeninviting/${
        activeSubscription.value?.id
      }?allowOpenInviting=${!openInviteState.value}`,
    );
    toggleOpenInviteState();
  } catch (e) {
    openInviteSettingError.value =
      (e as AxiosError).response?.data ?? "Error updating open invite setting";
  } finally {
    saveInProgress.value = false;
  }
};

const openCancelSubscriptionModal = (id: string) => {
  subscriptionToCancelId.value = id;
  toggleCancelSubscriptionModal();
};

const cancelSubscription = async (id: string) => {
  subscriptionToCancelId.value = id;
  saveInProgress.value = true;
  try {
    await axios.post(`/api/admin/cancelsubscription?subscriptionId=${id}`);
    toggleCancelSubscriptionModal();
    emit("revalidate-org-data");
  } catch (e) {
    cancelSubscriptionErrorMessage.value = "There was an error cancelling the subscription";
  } finally {
    saveInProgress.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_ctx.subscriptions)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ updating: saveInProgress.value })
      }, [
        (_unref(isCancelSubscriptionModalOpen))
          ? (_openBlock(), _createBlock(CancelSubscriptionModal, {
              key: 0,
              modelValue: "isCancelSubscriptionModalOpen",
              subscriptionId: subscriptionToCancelId.value,
              cancelError: cancelSubscriptionErrorMessage.value,
              onCancelSubscription: cancelSubscription,
              onToggleCancelSubscriptionModal: _unref(toggleCancelSubscriptionModal)
            }, null, 8, ["subscriptionId", "cancelError", "onToggleCancelSubscriptionModal"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayCancelledSubscriptions).value = $event)),
              id: "display-cancelled"
            }, null, 512), [
              [_vModelCheckbox, displayCancelledSubscriptions.value]
            ])
          ]),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSubscriptions.value, (sub) => {
              return (_openBlock(), _createElementBlock("li", {
                key: sub.id,
                onClick: _withModifiers(($event: any) => (setActiveSubscription(sub)), ["stop"]),
                class: _normalizeClass({ active: isActive(sub.id) }),
                "data-test": "subscription-list-item"
              }, [
                _createTextVNode(_toDisplayString(getSubscriptionDisplayName(sub)) + " ", 1),
                (isActive(sub.id))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "ml-2",
                      onClick: ($event: any) => (openCancelSubscriptionModal(sub.id))
                    }, "Cancel", 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_6))
            }), 128))
          ])
        ]),
        (activeSubscription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", {
                  href: `/admin/crmexport/subscriptiondata/${activeSubscription.value.id}`,
                  "data-test": "subscription-data-export-link"
                }, "Data Export", 8, _hoisted_10)
              ]),
              _createElementVNode("table", _hoisted_11, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_12,
                    _createElementVNode("td", _hoisted_13, _toDisplayString(planTitle.value), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _createElementVNode("td", _hoisted_15, _toDisplayString(subscriptionStartDate.value), 1)
                  ]),
                  (activeSubscription.value.subscriptionEndTime)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                        _createElementVNode("th", null, [
                          _createTextVNode(" End date "),
                          (isJyreAssess.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(Deadline for Assess subscriptions)"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _withDirectives(_createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(subscriptionEndDate.value) + " ", 1),
                            _withDirectives(_createElementVNode("a", {
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleEditDeadline) && _unref(toggleEditDeadline)(...args))),
                              "data-test": "sub-edit-end-date"
                            }, _hoisted_20, 512), [
                              [_vShow, isJyreAssess.value]
                            ])
                          ], 512), [
                            [_vShow, !_unref(isEditingDeadline)]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (activeSubscription.value.billingCycle)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("td", _hoisted_23, _toDisplayString(activeSubscription.value.billingCycle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _hoisted_24,
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: copyInviteCode,
                        "data-test": "sub-invite-code"
                      }, _toDisplayString(inviteCode.value), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_25,
                    _createElementVNode("td", _hoisted_26, _toDisplayString(activeSubscription.value.status), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_27,
                    _createElementVNode("td", null, [
                      (activeSubscription.value.owner)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("a", {
                              href: '/admin/user/details/' + activeSubscription.value.owner.id,
                              "data-test": "sub-owner"
                            }, _toDisplayString(activeSubscription.value.owner?.firstName) + " " + _toDisplayString(activeSubscription.value.owner?.lastName), 9, _hoisted_29)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, "This is a managed subscription"))
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_31,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            onChange: onToggleOpenInviting,
                            checked: _unref(openInviteState)
                          }, null, 40, _hoisted_34),
                          _hoisted_35
                        ]),
                        (openInviteSettingError.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(openInviteSettingError.value), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_37,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("div", _hoisted_39, [
                          _createTextVNode(_toDisplayString(updatedLicenceCount.value ?? licenceCount.value) + " ", 1),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleEditLicenceCount) && _unref(toggleEditLicenceCount)(...args))),
                            "data-test": "sub-edit-licences"
                          }, _hoisted_41)
                        ], 512), [
                          [_vShow, !_unref(isEditingLicenceCount)]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_42,
                    _createElementVNode("td", _hoisted_43, [
                      _createTextVNode(_toDisplayString(activeSubscription.value.licences.length) + " ", 1),
                      _createElementVNode("span", _hoisted_44, "(" + _toDisplayString(availableLicences.value) + ")", 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_45,
                    _createElementVNode("td", _hoisted_46, _toDisplayString(activeSubscription.value.chargebeeSubscriptionId), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_47,
                    _createElementVNode("td", _hoisted_48, _toDisplayString(activeSubscription.value.chargebeeCustomerId), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
}
}

})